import React, { useEffect, useState } from 'react';
import { BedDouble, Users, CalendarCheck, DollarSign, Home, UserCheck } from 'lucide-react';
import api from '../services/api';

const StatCard = ({ icon: Icon, label, value, color }) => (
  <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="text-2xl font-bold text-gray-800 mt-1">{value}</p>
      </div>
      <div className={`p-3 rounded-full ${color}`}>
        <Icon size={22} className="text-white" />
      </div>
    </div>
  </div>
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/dashboard/stats').then(r => setStats(r.data)).catch(console.error);
  }, []);

  if (!stats) return <div className="flex items-center justify-center h-64 text-gray-400">Loading...</div>;

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-6">Dashboard</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <StatCard icon={BedDouble} label="Total Rooms" value={stats.totalRooms} color="bg-purple-500" />
        <StatCard icon={Home} label="Available" value={stats.availableRooms} color="bg-green-500" />
        <StatCard icon={Users} label="Occupied" value={stats.occupiedRooms} color="bg-orange-500" />
        <StatCard icon={CalendarCheck} label="Reserved" value={stats.reservedRooms} color="bg-blue-500" />
        <StatCard icon={UserCheck} label="Active Students" value={stats.activeStudents} color="bg-pink-500" />
        <StatCard icon={Users} label="Total Students" value={stats.totalStudents} color="bg-indigo-500" />
        <StatCard icon={CalendarCheck} label="Reservations" value={stats.totalReservations} color="bg-yellow-500" />
        <StatCard icon={DollarSign} label="Monthly Revenue" value={`Rs. ${stats.monthlyRevenue.toLocaleString()}`} color="bg-teal-500" />
      </div>
    </div>
  );
}
